import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Tab, TabContent, TabsList } from '~/components/Tabs';
import type { CreateTripTab } from '~/stores/playgroundStore';
import { PlaygroundIndexForm } from '../PlaygroundIndexForm/PlaygroundIndexForm';
import { PlaygroundStartEndForm } from '../PlaygroundStartEndForm/PlaygroundStartEndForm';
export function PlaygroundStartEndTabs() {
  const $ = _c(14);
  const t = useTranslations("content.map");
  const areOneWayTripsEnabled = process.env.NEXT_PUBLIC_FF_ENABLE_ONE_WAY_TRIPS === "true";
  if (areOneWayTripsEnabled) {
    let t0;
    if ($[0] !== t) {
      t0 = t("tabs_aria_label");
      $[0] = t;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== t) {
      t1 = t("tab_round_trip");
      $[2] = t;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t1) {
      t2 = <Tab variant="minimal" id="round-trip">{t1}</Tab>;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== t) {
      t3 = t("tab_one_way_trip");
      $[6] = t;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== t3) {
      t4 = <Tab variant="minimal" id="one-way-trip">{t3}</Tab>;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t0 || $[11] !== t2 || $[12] !== t4) {
      t5 = <TabsList variant="minimal" ariaLabel={t0}>{t2}{t4}</TabsList>;
      $[10] = t0;
      $[11] = t2;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  return null;
}

// Note: to be deprecated soon
export function TabbedPlaygroundIndexOriginsForm(t0) {
  const $ = _c(11);
  const {
    isHeroCta,
    variant,
    travelType
  } = t0;
  let t1;
  if ($[0] !== isHeroCta || $[1] !== travelType || $[2] !== variant) {
    t1 = <TabContent id="round-trip"><PlaygroundIndexForm isHeroCta={isHeroCta} variant={variant} travelType={travelType} /></TabContent>;
    $[0] = isHeroCta;
    $[1] = travelType;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isHeroCta || $[5] !== travelType || $[6] !== variant) {
    t2 = <TabContent id="one-way-trip"><PlaygroundIndexForm isHeroCta={isHeroCta} variant={variant} travelType={travelType} /></TabContent>;
    $[4] = isHeroCta;
    $[5] = travelType;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
type TabbedPlaygroundStartEndFormProps = {
  isHeroCta: boolean;
  variant: 'module' | 'page';
  travelType: CreateTripTab;
};
export function TabbedPlaygroundStartEndForm(t0) {
  const $ = _c(12);
  const {
    travelType,
    variant,
    isHeroCta
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PlaygroundStartEndTabs />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isHeroCta || $[2] !== travelType || $[3] !== variant) {
    t2 = <TabContent id="round-trip"><PlaygroundStartEndForm travelType={travelType} variant={variant} isHeroCta={isHeroCta} /></TabContent>;
    $[1] = isHeroCta;
    $[2] = travelType;
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isHeroCta || $[6] !== travelType || $[7] !== variant) {
    t3 = <TabContent id="one-way-trip"><PlaygroundStartEndForm travelType={travelType} variant={variant} isHeroCta={isHeroCta} /></TabContent>;
    $[5] = isHeroCta;
    $[6] = travelType;
    $[7] = variant;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export function PlaygroundStartEndPanel(t0) {
  const $ = _c(11);
  const {
    travelType,
    variant,
    isHeroCta
  } = t0;
  let t1;
  if ($[0] !== isHeroCta || $[1] !== travelType || $[2] !== variant) {
    t1 = <TabContent id="round-trip"><PlaygroundStartEndForm travelType={travelType} variant={variant} isHeroCta={isHeroCta} /></TabContent>;
    $[0] = isHeroCta;
    $[1] = travelType;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isHeroCta || $[5] !== travelType || $[6] !== variant) {
    t2 = <TabContent id="one-way-trip"><PlaygroundStartEndForm travelType={travelType} variant={variant} isHeroCta={isHeroCta} /></TabContent>;
    $[4] = isHeroCta;
    $[5] = travelType;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}